import React from "react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { Button, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

export interface ResultsPagination {
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

interface ServerPaginationControlsProps {
  pagination: ResultsPagination;
  onPageChange: (page: number) => void;
}

export const ServerPaginationControls: React.FC<ServerPaginationControlsProps> = ({
  pagination,
  onPageChange,
}) => {
  const startItem = (pagination.page - 1) * pagination.pageSize + 1;
  const endItem = Math.min(pagination.page * pagination.pageSize, pagination.total);

  return (
    <Stack direction="row" justify="between" align="center" className="al-pt-4 al-border-t al-mt-4">
      <Typography size="sm" className="al-text-gray-600">
        Showing {startItem}-{endItem} of {pagination.total} results
      </Typography>

      <Stack direction="row" gap="xs" align="center">
        <Button
          onClick={() => onPageChange(pagination.page - 1)}
          disabled={!pagination.hasPrev}
          variant="outline"
          size="sm"
        >
          <IconChevronLeft className="al-w-4 al-h-4 al-mr-1" />
          Previous
        </Button>

        <Typography size="sm" className="al-text-gray-600 al-px-2">
          Page {pagination.page} of {pagination.totalPages}
        </Typography>

        <Button
          onClick={() => onPageChange(pagination.page + 1)}
          disabled={!pagination.hasNext}
          variant="outline"
          size="sm"
        >
          Next
          <IconChevronRight className="al-w-4 al-h-4 al-ml-1" />
        </Button>
      </Stack>
    </Stack>
  );
};
